// 越南语
export default {
  "请输入手机号或用户名": "Vui lòng nhập số điện thoại hoặc tên người dùng",
  "请输入密码": "Vui lòng nhập mật khẩu",
  "自动登录": "Đăng nhập tự động",
  "游戏试玩": "Trải nghiệm trò chơi miễn phí",
  "忘记密码": "Quên mật khẩu",
  "登录账户": "Đăng nhập tài khoản",
  "联系客服": "Liên hệ chăm sóc khách hàng",
  "注册账户": "Đăng ký tài khoản",
  "请输入确认密码": "Vui lòng nhập lại mật khẩu",

  "推荐人": "Người giới thiệu",
  "请输入验证码": "Vui lòng nhập mã xác nhận",
  "注册": "Đăng ký",
  "登录": "Đăng nhập",
  "返回登录": "Quay lại đăng nhập",
  "复制成功": "Sao chép thành công",
  "客服": "Hỗ trợ khách hàng",
  "大厅": "Sảnh chính",
  "发现": "Khám phá",
  "优惠": "Ưu đãi",
  "我的": "Của tôi",
  "会话": "Cuộc trò chuyện",
  "公告通知": "Thông báo",
  "上下分如有问题请及时联系客服": "Nếu có vấn đề về nạp/rút tiền, vui lòng liên hệ chăm sóc khách hàng kịp thời",
  "在线客服": "Hỗ trợ khách hàng trực tuyến",
  "提供各类问题疑难排解": "Cung cấp giải pháp cho các loại sự cố và vấn đề khác nhau",
  "Telegram客服": "Telegram",
  "消息中心": "Trung tâm thông báo",
  "公告": "Thông cáo",
  "站内信": "Thư nội bộ",
  "没有更多了": "Không còn nữa",
  "请先登录或者注册": "Vui lòng đăng nhập hoặc đăng ký trước",
  "充值": "Nạp tiền",
  "转账": "Chuyển khoản",
  "提现": "Rút tiền",
  "IOS用户注意": "Lưu ý cho người dùng iOS",
  "尊敬的U8会员您好": "Kính chào thành viên U8 quý mến",
  "sys_content1": "Phiên bản mới của ứng dụng U8 International iOS đã được sửa lỗi và chính thức ra mắt, hiện đã có thể tải về.",
  "sys_content2": "Nhưng để đảm bảo truy cập ổn định lâu dài, chúng tôi khuyên bạn nên ưu tiên mở bằng trình duyệt Safari.",
  "sys_content3": "Nhấn vào phần dưới cùng📤Nhấn nút Chia sẻ” → Chọn “Thêm vào Màn hình chính” để truy cập nhanh vào nền tảng.",

  "sys_content4": "Nếu muốn sử dụng ứng dụng, vui lòng truy cập trang web chính thức.",
  "sys_content5": "Truy cập trang chủ, nhấn vào nút 【Tải xuống】 ở góc trên bên phải để lấy phiên bản mới nhất.",
  "sys_content6": "Nếu có thắc mắc, vui lòng liên hệ với bộ phận hỗ trợ chính thức.",

  "sys_content7": "Hỗ trợ xử lý",
  "sys_content8": "Cảm ơn sự ủng hộ và thông cảm của bạn!",
  "sys_content9": "Đội ngũ vận hành U8 International",
  "公平": "Công bằng",
  "公正": "Công lý",
  "公开": "Công khai",
  "官方投注机器人":  "Robot đặt cược chính thức",
  "sys_content10": "Thực hiện trực tiếp các thao tác như chơi game, nạp tiền, rút tiền, v.v.",
  "搜索": "Tìm kiếm",
  "sys_content11": "Cảm ơn sự thông cảm và ủng hộ của bạn, chúc bạn chơi game vui vẻ!",
  "今日不再弹出": "Không hiển thị lại hôm nay",
  "添加": "Thêm vào",
  "到手机主页屏幕": "Vào màn hình chính của điện thoại",
  "选择分享按钮": "Chọn nút chia sẻ",
  "点击": "Nhấn vào",
  "加至主画面": "Thêm vào màn hình chính",
  "点击「加入」按钮": "Nhấn vào nút 「Thêm」",
  "存款": "Gửi tiền",
  "网银转账": "Chuyển khoản ngân hàng trực tuyến",
  "微信": "WeChat",
  "支付宝": "Alipay",
  "收款账号": "Tài khoản nhận tiền",
  "复制": "Sao chép",
  "银行户名": "Tên chủ tài khoản ngân hàng",
  "开户行": "Ngân hàng mở tài khoản",
  "银行地址": "Địa chỉ ngân hàng",
  "开户银行": "Ngân hàng phát hành tài khoản",
  "选择开户银行": "Chọn ngân hàng mở tài khoản",
  "存款人姓名": "Tên người gửi tiền",
  "请输入存款人姓名": "Vui lòng nhập tên người gửi tiền",
  "请务必输入正确的存款人姓名": "Để tiền được chuyển ngay lập tức, vui lòng chắc chắn nhập đúng tên người gửi tiền.",
  "银行卡号": "Số thẻ ngân hàng",
  "请输入银行卡号": "Vui lòng nhập số thẻ ngân hàng",
  "开户行地址": "Địa chỉ ngân hàng mở tài khoản",
  "请输入开户行地址": "Địa chỉ ngân hàng mở tài khoản",
  "请输入银行开户行地址": "Vui lòng nhập địa chỉ ngân hàng mở tài khoản",
  "存款金额": "Số tiền nạp",
  "请输入取款金额": "Vui lòng nhập số tiền rút",
  "元": "VND",
  "USDT价格稳定": "Giá USDT ổn định",
  "流通性高": "Tính thanh khoản cao",
  "不受监管": "Không bị kiểm soát",
  "了解更多": "Tìm hiểu thêm",
  "绑定协议地址": "Chuyển tiền giữa các sàn giao dịch",
  "交易所划转": "Liên kết địa chỉ hợp đồng",
  "完成取款": "Hoàn tất rút tiền",
  "钱包协议": "Giao thức ví",
  "温馨提示": "Lời nhắc thân thiện",
  "温馨提示内容": "Vui lòng chọn đúng giao thức thanh toán USDT. Nếu bạn chọn sai giao thức, nền tảng sẽ không nhận được thanh toán của bạn, và chúng tôi sẽ không chịu bất kỳ trách nhiệm nào về việc này！",
  "立即存款": "Nạp tiền ngay",
  "存款遇到问题": "Gặp sự cố khi nạp tiền",
  "联系": "Liên hệ",
  "人工客服": "Hỗ trợ khách hàng trực tiếp",
  "解决": "Giải quyết",
  "银行类型": "Loại ngân hàng",
  "请输入银行类型": "Vui lòng nhập loại ngân hàng",
  "请输入金额区间": "Vui lòng nhập số tiền trong khoảng {min_price}-{max_price}！",
  "等待后台审核": "Gửi thành công, vui lòng chờ bộ phận kiểm duyệt xử lý",
  "场馆转账": "Chuyển tiền giữa các sòng/địa điểm chơi",
  "余额自动转入": "Số dư tự động chuyển vào",
  "启用后余额自动转入转出游戏场馆": "Sau khi kích hoạt, số dư sẽ tự động chuyển vào hoặc ra khỏi sòng/trò chơi.",
  "请输入转账金额": "Vui lòng nhập số tiền chuyển khoản",
  "全部转入": "Chuyển toàn bộ vào",
  "可转账金额": "Số tiền có thể chuyển",
  "确认转账": "Xác nhận chuyển khoản",
  "场馆余额明细": "Chi tiết số dư sòng/trò chơi",
  "点击查看全部场馆余额": "Nhấn để xem toàn bộ số dư các sòng/trò chơi",
  "主钱包": "Ví chính",
  "一键取回": "Rút về chỉ với một lần nhấn",
  "收起": "Thu gọn",
  "展开": "Mở rộng",
  "请输入操作金额": "Vui lòng nhập số tiền thao tác",
  "场馆内钱包不支持互转": "Ví trong sòng/trò chơi không hỗ trợ chuyển đổi lẫn nhau",
  "操作成功": "Thao tác thành công",
  "VIP特权": "Đặc quyền VIP",
  "已达标": "Đã đạt tiêu chuẩn",
  "未达标": "Chưa đạt tiêu chuẩn",
  "累计存款": "Tổng số tiền nạp tích lũy",
  "流水要求": "Yêu cầu doanh thu cược",
  "VIP最高返水比例": "Tỷ lệ hoàn trả cao nhất cho VIP",
  "VIP等级": "Cấp độ VIP",
  "真人": "Trực tiếp",
  "体育": "Thể thao",
  "电竞": "Esports",
  "棋牌": "Bài và cờ",
  "电子": "điện tử",
  "彩票": "xổ số",
  "活动规则": "Quy tắc hoạt động",
  "晋升标准": "Tiêu chuẩn thăng chức",
  "rule_content1": "Khi tổng số tiền gửi và tổng số giao dịch của thành viên đạt đến mức yêu cầu tương ứng, thành viên sẽ được nâng cấp lên cấp VIP tương ứng trước 24 giờ ngày hôm sau.。",
  "晋升顺序": "Thứ tự thăng chức",
  "rule_content2": "Khi đạt được yêu cầu tương ứng, cấp VIP có thể được thăng cấp mỗi ngày, nhưng không thể thăng cấp vượt cấp.。",
  "保级要求": "Yêu cầu trụ hạng",
  "rule_content3": "Sau khi đạt được một cấp độ VIP nhất định, thành viên phải hoàn thành yêu cầu doanh thu để duy trì cấp độ trong vòng 90 ngày. Nếu trong thời gian này thành viên được thăng cấp, yêu cầu duy trì cấp độ sẽ được tính lại theo cấp độ hiện tại.。",
  "降级标准": "Tiêu chuẩn hạ cấp",
  "rule_content4": "Nếu thành viên không hoàn thành yêu cầu doanh thu tương ứng để duy trì cấp độ trong một quý (tính theo 90 ngày), hệ thống sẽ tự động hạ cấp một bậc, và các khoản hoàn tiền cùng các ưu đãi khác cũng sẽ được điều chỉnh theo cấp độ mới sau khi hạ cấp.。",
  "VIP返水": "Hoàn tiền VIP",
  "rule_content5": "Số tiền hoàn lại VIP được tính dựa trên các cược hợp lệ của thành viên trong khoảng thời gian từ 00:00 đến 23:59 theo giờ Bắc Kinh trong ngày. Tất cả số tiền hoàn lại từ các cược trong ngày sẽ được chuyển vào Trung tâm Phúc lợi trong vòng 24 giờ sau khi kết thúc ngày thanh toán cược. Vui lòng truy cập Trung tâm Phúc lợi trong Trung tâm Cá nhân để nhận tiền hoàn lại thủ công. (Hoàn lại VIP có thể rút tiền sau khi đạt 1 lần doanh thu)",
  "rule_content6": "U8 Entertainment reserves the right to modify, suspend, and make the final interpretation of the event.",
  "取款": "Rút tiền",
  "银行卡取款": "Rút tiền từ thẻ ngân hàng",
  "钱包金额": "Số tiền trong ví",
  "一键回收": "Một nút thu hồi",
  "中心钱包": "Ví trung tâm",
  "游戏钱包": "trò chơi",
  "选择USDT地址": "Chọn địa chỉ USDT",
  "请选择USDT地址": "Chọn địa chỉ USDT",
  "添加USDT地址": "Thêm địa chỉ USDT",
  "打码量": "Lượng mã hóa",
  "取款金额": "Số tiền rút",
  "最大金额": "Số tiền tối đa",
  "支付密码": "Mật khẩu thanh toán",
  "请输入支付密码": "Vui lòng nhập mật khẩu thanh toán",
  "每笔手续费": "Mỗi khoản phí dịch vụ",
  "折合USDT": "Tương đương USDT",
  "参考汇率": "Tỷ giá tham khảo",
  "实时变化": "Thay đổi theo thời gian thực",
  "实际到账": "Thực tế đã nhận được tiền",
  "选择银行卡": "Chọn thẻ ngân hàng",
  "请选择银行卡": "Chọn thẻ ngân hàng",
  "添加银行卡": "Thêm thẻ ngân hàng",
  "立即取款": "Rút tiền ngay lập tức",
  "取款遇到问题": "Gặp sự cố khi rút tiền",
  "真实姓名": "Tên thật",
  "绑定真实姓名后不可修改": "Sau khi liên kết tên thật, không thể sửa đổi.",
  "确认修改": "Xác nhận sửa đổi",
  "请选择您要提现到的银行卡": "Vui lòng chọn thẻ ngân hàng mà bạn muốn rút tiền về.",
  "单笔取款不能低于100元": "Mỗi lần rút tiền không được dưới 100 nhân dân tệ.",
  "请输入您的支付密码": "Vui lòng nhập mật khẩu thanh toán của bạn",
  "请填写用户实名信息": "Vui lòng điền thông tin tên thật của người dùng",
  "提交成功": "Gửi thành công",
  "优惠活动": "Chương trình khuyến mãi",
  "全部优惠": "Tất cả ưu đãi",
  "限时活动": "Hoạt động có thời hạn",
  "新人首存": "Tiền gửi đầu tiên của người mới",
  "日常活动": "Hoạt động hàng ngày",
  "暂未设置签名": "Chưa thiết lập chữ ký",
  "账户总资产": "Tổng tài sản tài khoản",
  "我的钱包": "Ví của tôi",
  "账户明细": "Chi tiết tài khoản",
  "投注记录": "Lịch sử đặt cược",
  "安全设置": "Cài đặt an toàn",
  "我的等级": "Cấp độ của tôi",
  "VIP中心": "Trung tâm VIP",
  "邀请好友": "Mời bạn bè",
  "推荐送礼金": "Gợi ý quà tặng tiền mặt",
  "官方公告": "Thông báo chính thức",
  "坐收盈利": "thu lợi nhuận",
  "合营计划": "Kế hoạch hợp tác",
  "加入我们": "Tham gia cùng chúng tôi",
  "月入百万": "Thu nhập hàng tháng lên đến một triệu",
  "NG扑克": "NG Poker",
  "活动中心": "Trung tâm hoạt động",
  "平台优惠回馈活动": "Chương trình khuyến mãi ưu đãi của nền tảng",
  "输赢比例": "Tỷ lệ thắng thua",
  "功能设置": "Cài đặt chức năng",
  "反水比例": "Tỷ lệ nước ngược",
  "反水中心": "Trung tâm chống nước",
  "修改登录密码": "Thay đổi mật khẩu đăng nhập",
  "个人资料": "Thông tin cá nhân",
  "个人头像": "Hình đại diện cá nhân",
  "用户名": "Tên người dùng",
  "请输入用户名": "Tên người dùng",
  "请输入真实姓名": "Tên thật",
  "出生日期": "Ngày sinh",
  "请选择出入日期": "Ngày sinh",
  "手机号码": "Số điện thoại di động",
  "绑定手机号保障账号安全": "Đăng ký số điện thoại di động để bảo vệ tài khoản an toàn",
  "电子邮箱": "Email",
  "绑定邮箱保护账号安全": "Bind email to protect account security",
  "请输入正确手机号": "Vui lòng nhập số điện thoại di động chính xác",
  "请输入正确邮箱号": "Vui lòng nhập địa chỉ email chính xác",
  "请输入正确的日期格式": "Vui lòng nhập định dạng ngày tháng chính xác.",
  "邀请链接": "Liên kết mời",
  "立即邀请": "Mời ngay lập tức",
  "礼金介绍": "Giới thiệu về tiền mừng",
  "明细记录": "Chi tiết ghi chép",
  "下级概览": "Tổng quan cấp dưới",
  "下级成员统计": "Thống kê thành viên cấp dưới",
  "本月新增": "Thêm mới trong tháng này",
  "本月活跃成员": "Thành viên hoạt động trong tháng này",
  "本月有效活跃": "Hoạt động hiệu quả trong tháng này",
  "今日新增": "Hôm nay có thêm",
  "今日活跃": "Hoạt động hôm nay",
  "本月新增有效会员": "Thành viên mới có hiệu lực trong tháng này",
  "今日存款": "Tiền gửi hôm nay",
  "数据列表": "Danh sách dữ liệu",
  "礼金记录": "Ghi chép tiền mừng",
  "好友明细": "Chi tiết bạn bè",
  "重置": "Đặt lại",
  "查询": "truy vấn",
  "日期": "Ngày",
  "礼金": "tiền mừng",
  "备注": "Ghi chú",
  "保存链接": "Lưu liên kết",
  "保存图片": "Lưu hình ảnh",
  "保存二维码": "Lưu mã QR",
  "取消": "Hủy bỏ",
  "链接已复制到剪贴板": "Liên kết đã được sao chép vào khay nhớ tạm",
  "复制链接失败": "Sao chép liên kết không thành công",
  "合营部": "Phòng Hợp tác",
  "立即咨询": "Liên hệ ngay",
  "咨询": "Tư vấn",
  "联系方式": "Thông tin liên hệ",
  "请输入您的联系方式": "Thông tin liên hệ",
  "申请理由": "Lý do nộp đơn",
  "请输入申请理由": "Lý do nộp đơn",
  "盈利总额": "Tổng lợi nhuận",
  "充值总额": "Tổng số tiền nạp",
  "提现总额": "Tổng số tiền rút",
  "投注总额": "Tổng số tiền đặt cược",
  "设置": "Cài đặt",
  "消息时间显示": "Thời gian hiển thị tin nhắn",
  "中奖提示": "Thông báo trúng thưởng",
  "安静模式": "Chế độ im lặng",
  "关于CG": "Về CG",
  "帮助与反馈": "Trợ giúp và phản hồi",
  "退出": "Thoát",
  "返水比例": "Tỷ lệ hoàn lại tiền",
  "当日累计投注": "Tổng số tiền cược trong ngày",
  "转运金": "Chuyển tiền",
  "开元棋牌": "Kaiyuan Chess",
  "设置提现密码": "Đặt mật khẩu rút tiền",
  "原密码": "Mật khẩu gốc",
  "请输入当前密码": "Mật khẩu hiện tại",
  "新密码": "Mật khẩu mới",
  "请输入新密码": "Vui lòng nhập mật khẩu mới",
  "确认新密码": "Xác nhận mật khẩu mới",
  "请再次输入密码": "Vui lòng nhập lại mật khẩu",
  "请输入旧密码": "Vui lòng nhập mật khẩu cũ",
  "请输入正确的旧密码长度": "Vui lòng nhập độ dài mật khẩu cũ chính xác",
  "请输入正确的新密码长度": "Vui lòng nhập độ dài mật khẩu mới chính xác",
  "两次密码不一致": "Hai lần mật khẩu không khớp nhau",
  "新旧密码不能一致": "Mật khẩu cũ và mới không được giống nhau.",
  "密码修改成功": "Mật khẩu đã được thay đổi thành công",
  "app下载": "Tải ứng dụng",
  "可扫描下发二维码进行app下载": "Quét mã QR để tải ứng dụng",
  "立即下载": "Tải xuống ngay",
  "download_content1": "Cần tải xuống, cài đặt và đăng ký trong cùng một môi trường mạng, vui lòng không chuyển đổi mạng; Nếu không thể cài đặt bình thường, vui lòng sử dụng trình duyệt có sẵn trên điện thoại để mở trang này.",
  "请输入金额": "Vui lòng nhập số tiền",
  "转入": "Chuyển vào",
  "平台钱包": "ví điện tử",
  "操作金额不能为0": "Số tiền giao dịch không được là 0",
  "转入成功": "Chuyển thành công",
  "天": "trời",
  "时": "thời",
  "分": "phân",
  "秒": "giây",
  "剩余领取次数": "Số lần nhận còn lại",
  "次": "lần sau",
  "主账号余额": "Số dư tài khoản chính",
  "账户充值": "Nạp tiền vào tài khoản",
  "账户提现": "Rút tiền từ tài khoản",
  "下线转账": "Chuyển khoản ngoại tuyến",
  "订单号": "Số đơn hàng",
  "金额": "Số tiền",
  "空空如也": "trống rỗng",
  "今日": "Hôm nay",
  "近7日": "Gần 7 ngày",
  "近15日": "Gần 15 ngày",
  "近30日": "Gần 30 ngày",
  "转出": "Chuyển ra",
  "赠送": "Tặng",
  "反水": "phản bội",
  "未定义": "Chưa xác định",
  "待审核": "Chờ duyệt",
  "审核通过": "Đã duyệt",
  "审核拒绝": "Từ chối phê duyệt",
  "失败": "thất bại",
  "成功": "thành công",
  "待结算": "Chờ thanh toán",
  "全平台": "Tất cả các nền tảng",
  "大舞台": "Sân khấu lớn",
  "官方动态": "Thông tin chính thức",
  "动态": "Động thái",
  "活动申请记录": "Hồ sơ đăng ký hoạt động",
  "活动标题": "Tiêu đề hoạt động",
  "申请时间": "Thời gian nộp đơn",
  "状态": "Trạng thái",
  "未约定": "Không có thỏa thuận",
  "通过": "Thông qua",
  "拒绝": "từ chối",
  "派彩": "phát thưởng",
  "无效注单": "Phiếu đặt hàng không hợp lệ",
  "已结算": "Đã thanh toán",
  "未结算": "Chưa thanh toán",
  "返水中心": "Trung tâm hoàn tiền",
  "返水记录": "Lịch sử hoàn tiền",
  "点击领取": "Nhấp để nhận",
  "累计领取": "Tổng số tiền đã nhận",
  "待领取": "Chờ nhận",
  "返水金额": "Số tiền hoàn lại",
  "返水时间": "Thời gian hoàn tiền",
  "领取时间": "Thời gian nhận",
  "暂未领取": "Chưa nhận",
  "暂无领取额度": "Chưa nhận",
  "加载中": "đang tải",
  "最多支持添加5个地址": "Hỗ trợ thêm tối đa 5 địa chỉ",
  "认证失败": "Xác thực không thành công",
  "您的账号登陆过期，请重新登陆": "Tài khoản đăng nhập của bạn đã hết hạn, vui lòng đăng nhập lại",
  "提示": "gợi ý",
  "您确定要退出登录吗": "Bạn có chắc chắn muốn đăng xuất không",
  "精彩内容等你来体验，快来登录吧": "Nội dung tuyệt vời đang chờ bạn trải nghiệm, hãy đến và đăng nhập",
  "立即下载APP": "Tải APP Ngay",
  "余额": "THĂNG BẰNG",

  "活动详情": "Chi tiết sự kiện",
  "活动说明": "Mô tả hoạt động",
  "立即申请": "Đăng ký ngay bây giờ",
  "前往登录": "Đi đến đăng nhập",

  "代理系统": "hệ thống đại lý",
  "下属代理": "Phụ thuộc đại lý",
  "代理总览": "Phụ thuộc đại lý",
  "直属玩家": "Người chơi trực thuộc",
  "盈亏统计": "Thống kê lãi lỗ",
  "账单查询": "Tra cứu hóa đơn",
  "充值记录": "Lịch sử nạp tiền",
  "提现记录": "Lịch sử rút tiền",
  "个人信息": "Thông tin cá nhân",
  "下级在线": "Thành viên cấp dưới trực tuyến",
  "我的余额": "Số dư của tôi",
  "附属代理人": "Đại lý phụ thuộc",
  "附属玩家": "Người chơi trực thuộc",
  "今日投注": "Đặt cược hôm nay",
  "今日收入": "Thu nhập hôm nay",
  "历史收入": "Lịch sử thu nhập",
  "邀请码": "Mã mời",

  "开盘中": "Đang mở phiên",
  "已封盘": "Đã đóng phiên",
  "下注倒计时": "Đếm ngược đặt cược",
  "期": "Kỳ",
  "期开奖结果": "Kết quả xổ số",
  "已开启": "Đã mở",
  "已关闭": "Đã đóng",
  "期号": "Số kỳ",
  "号码": "Số",
  "总和": "Tổng hợp",
  "总和两面": "Tổng hợp hai mặt",
  "首页": "Trang đầu",
  "上一页": "Trang trước",
  "下一页": "Trang sau",
  "尾页": "Trang cuối",
  "请输入": "Vui lòng nhập",
  "下注": "Đặt cược",
  "大小单双": "Tài xỉu chẵn lẻ",
  "大": "Tài",
  "小": "Xỉu",
  "单": "Lẻ",
  "双": "Chẵn",
  "大单": "Tài lẻ",
  "大双": "Tài chẵn",
  "小单": "Xỉu lẻ",
  "小双": "Xỉu chẵn",
  "形态": "Hình thái",
  "豹子": "Báo tử",
  "对子": "Đôi",
  "顺子": "Thẳng",
  "极大": "Cực tài",
  "极小": "Cực xỉu",
  "特码": "Đặc mã",
  "清空": "Xóa hết",
  "立即下注": "Đặt cược ngay",
  "开奖号码": "Số mở thưởng",
  "第": "Thứ",
  "投注时间": "Thời gian đặt cược",
  "投注金额": "Số tiền đặt cược",
  "玩法": "Cách chơi",
  "盘类": "Loại cược",
  "派奖奖金": "Thưởng phát thưởng",
  "赔率": "Tỷ lệ cược",
  "返水": "Hoa hồng hoàn trả",
  "总投注": "Tổng cược",
  "有效投注": "Cược hợp lệ",
  "总派奖": "Tổng phát thưởng",
  "实际派奖": "Phát thưởng thực tế",
  "两面": "Hai mặt",
  "组合": "Kết hợp",
  "每页": "Mỗi trang",
  "条": "Mục",
  "编辑金额": "Chỉnh sửa số tiền",
  "恢复默认": "Phục hồi mặc định",
  "保存": "Lưu",
  "距离开奖": "Cách thời gian mở thưởng",
  "刷新": "Làm mới",
  "返回": "Quay lại",
  "当前第": "Hiện tại thứ",
  "数据统计详情": "Chi tiết thống kê dữ liệu",
  "值": "Giá trị",
  "未开期数": "Số kỳ chưa mở",
  "单路区": "Khu một đường",
  "间隔": "Khoảng cách",
  "咪牌": "Xem bài",

  "投注区": "Khu vực đặt cược",
  "游戏记录": "Lịch sử trò chơi",
  "路单区": "Khu lộ trình",
  "游戏规则": "Luật chơi",
  "开奖验证": "Xác minh kết quả",
  "开奖记录": "Lịch sử mở thưởng",
  "统计": "Thống kê",
  "大小": "Tài Xỉu",
  "极大小": "Cực Tài Xỉu",
  "已选": "Đã chọn",
  "注": "Cược",
  "共计": "Tổng cộng",
  "已中奖": "Đã trúng thưởng",
  "未开奖": "Chưa mở thưởng",
  "已退款": "Đã hoàn tiền",
  "语言": "ngôn ngữ",

  "六合彩": "Xổ số Hồng Kông",
  "初级": "Cấp cơ bản",
  "猜特码": "Đoán số đặc biệt",
  "猜特肖": "Đoán con giáp đặc biệt",
  "猜平肖": "Đoán con giáp bình thường",
  "猜类型": "Đoán loại hình",
  "平肖": "Con giáp bình thường",
  "鼠": "Tý",
  "牛": "Sửu",
  "虎": "Dần",
  "兔": "Mão",
  "龙": "Thìn",
  "蛇": "Tỵ",
  "马": "Ngọ",
  "羊": "Mùi",
  "猴": "Thân",
  "鸡": "Dậu",
  "狗": "Tuất",
  "猪": "Hợi",
  "类型": "Loại hình",
  "蓝波": "Sóng xanh",
  "绿波": "Sóng lục",
  "红波": "Sóng đỏ",
  "特肖": "Con giáp đặc biệt",
  "特鼠": "Chuột đặc biệt",
  "特牛": "Trâu đặc biệt",
  "特虎": "Hổ đặc biệt",
  "特兔": "Thỏ đặc biệt",
  "特龙": "Rồng đặc biệt",
  "特蛇": "Rắn đặc biệt",
  "特马": "Ngựa đặc biệt",
  "特羊": "Dê đặc biệt",
  "特鸡": "Gà đặc biệt",
  "特狗": "Chó đặc biệt",
  "特猪": "Heo đặc biệt",
  "特猴": "Chú khỉ đặc biệt",
  "什么也没有": "Không có gì cả",
  "进行中": "Đang diễn ra",
  "已结束": "Đã kết thúc",
  "快捷下注": "Đặt cược nhanh",
  "开奖走势": "Xu hướng mở thưởng",
  "开奖历史": "Lịch sử mở thưởng",
  "在线": "Trực tuyến",
  "快捷投注": "Đặt cược nhanh",
  "项": "Hạng mục",
  "需支付": "Cần thanh toán",
  "确认投注": "Xác nhận cược",
  "错误提示": "Thông báo lỗi",
  "管理员": "quản trị viên",
  "封盘中": "Đã đóng",
  "预计盈利": "lợi nhuận dự kiến",
  "投注成功": "Đặt cược thành công",
  "用户": "Người dùng",
  "时间": "Thời gian",
  "投注": "Đặt cược",
  "加拿大28": "Canada 28",
  "中级": "Trung cấp",
  "新澳门六合彩": "Xổ số Hồng Kông Ma Cao Mới",
  "澳门六合彩": "Xổ số Hồng Kông Ma Cao",
  "下注内容": "Nội dung cược",
  "合计总金额": "Tổng số tiền",
  "房间": "Phòng",
}



// WEBPACK FOOTER //
// ./src/locales/lang/Vietnamese.js